import { GxIcon } from '@garpix/garpix-web-components-react'
import { starIcon } from '@/images'
import classNames from 'classnames'
import React from 'react'
import style from './styles/tag.module.scss'

const ScoreTag = ({ title = '', size = 'medium' }): React.ReactElement => {
  return (
    <span
      className={classNames({
        [style.tag]: true,
        [style.theme_blue]: true,
        [style[`size_${size}`]]: true
      })}
    >
      <GxIcon src={starIcon} className={style.tag__icon} />
      {title}
    </span>
  )
}

export default ScoreTag
